export default __webpack_public_path__ + "static/media/RICARDO REVIGLIONO.48cd48e4.jpg";